import React from "react";
import ReactDOM from "react-dom/client";
import "../src/assets/css/index.css";
import "./assets/css/chillax.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import { LanguageProvider } from "./config/localization/LanguageProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </Provider>
);
